/**
 * Function for is editor know.
 * @returns {boolean}
 */
const isEditor = document.querySelector("div[data-gjs-type='wrapper']") !== null;

const isLivePreview = window.location.hostname.includes('.livepreview.');
const isLocalHost = window.location.hostname.includes('localhost');

const isDevEnvironment = () => {
  const currentHostName = window.location.hostname;
  const devHostIdentifier = [
    '-preview.',
    '.dev.',
    'canvas.',
    'localhost',
    '.livepreview.',
    '-routes.',
    'webbuilder.',
  ];
  return devHostIdentifier.some(hostPart => currentHostName.includes(hostPart));
};

export { isLivePreview, isDevEnvironment, isLocalHost };
export default isEditor;
